import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { useSeo } from "@/hooks/useSeo";
import { faqs, votingFaqs } from "@/mocks/faqs";

export default function FaqPage() {
  const allFaqs = [...faqs, ...votingFaqs];

  useSeo({
    title: "常见问题 - 爆料大赛投票规则与评选说明 | 爆料大赛",
    description:
      "爆料大赛常见问题解答，包含活动参加方式、投票是否影响排名、能否重复投票、入围名单如何产生与排名刷新频率等说明。",
    keywords: "爆料大赛常见问题,爆料大赛投票规则,爆料大赛评选说明,爆料大赛怎么投票",
    path: "/faq",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: allFaqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: "/faq" },
        ],
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1 pt-[68px]">
        <div className="w-full bg-background-100 border-b border-background-200">
          <div className="mx-auto max-w-4xl px-4 md:px-8 py-10 md:py-14">
            <Breadcrumb items={[{ label: "常见问题" }]} />
            <h1 className="mt-4 font-heading text-3xl md:text-5xl tracking-wide text-foreground-950">
              常见问题
            </h1>
            <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
              关于爆料大赛的参与方式、打分机制与排名规则，我们把大家问得最多的问题整理在这里。点击问题即可展开查看答案。
            </p>
          </div>
        </div>

        <section className="py-14 md:py-20">
          <div className="w-full px-4 md:px-8">
            <div className="mx-auto max-w-4xl">
              <h2 className="font-heading text-2xl md:text-3xl tracking-wide text-foreground-950 mb-6">
                活动与评选规则
              </h2>
              <FaqAccordion items={faqs} />
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-8">
            <div className="mx-auto max-w-4xl">
              <h2 className="font-heading text-2xl md:text-3xl tracking-wide text-foreground-950 mb-6">
                投票相关
              </h2>
              <FaqAccordion items={votingFaqs} />
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20">
          <div className="w-full px-4 md:px-8">
            <div className="mx-auto max-w-4xl rounded-lg bg-primary-950 px-6 md:px-10 py-10 text-center">
              <h2 className="font-heading text-2xl md:text-3xl tracking-wide text-background-50">
                还有问题没被解答？
              </h2>
              <p className="mt-3 text-sm md:text-base text-background-200 max-w-xl mx-auto">
                可以先浏览入围名单和排名结果，也可以直接来信反馈，我们会把高频问题补充进这个页面。
              </p>
              <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
                <Link
                  to="/finalists"
                  className="px-7 py-3.5 rounded-md bg-accent-500 text-accent-950 font-bold text-sm whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
                >
                  进入评选专区
                </Link>
                <Link
                  to="/about"
                  className="px-7 py-3.5 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
                >
                  联系我们反馈
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}